type PrefixedDocument = Document & { webkitFullscreenElement?: Element | null };

export const CHART_FULL_SCREEN_EVENT = 'vp:chartfullscreenchange';

const CHART_MARKER_CLASS = 'vp-chart-full-screen';
const CHANGE_EVENTS = ['fullscreenchange', 'webkitfullscreenchange', CHART_FULL_SCREEN_EVENT];

// seats.io has its own full-screen mode for where the API cannot go -- iPhone Safari, notably.
export const setChartFullScreen = (open: boolean, doc: Document = document): void => {
  if (doc.documentElement.classList.contains(CHART_MARKER_CLASS) === open) {
    return;
  }

  doc.documentElement.classList.toggle(CHART_MARKER_CLASS, open);
  doc.dispatchEvent(new Event(CHART_FULL_SCREEN_EVENT));
};

export const isFullScreen = (doc: Document = document): boolean =>
  doc.fullscreenElement != null ||
  (doc as PrefixedDocument).webkitFullscreenElement != null ||
  doc.documentElement.classList.contains(CHART_MARKER_CLASS);

export const onFullScreenChange = (listener: () => void, doc: Document = document): (() => void) => {
  CHANGE_EVENTS.forEach(name => doc.addEventListener(name, listener));

  return () => CHANGE_EVENTS.forEach(name => doc.removeEventListener(name, listener));
};
